import { combineReducers } from 'redux'
import apiLoaderReducer, { ApiLoaderState } from 'src/common/apiLoader/state/reducer'
import securityReducer, { SecurityState } from 'src/features/Security/state/reducer'
import menuReducer, { MenuState } from 'src/components/Sidebar/state/reducer'
import userReducer, { UserState } from 'src/features/User/state/reducer'
import commonReducer, { CommonState } from 'src/common/state/reducer'
import customerReducer, { CustomerState } from 'src/features/Customer/state/reducer'
import serviceReducer, { ServiceState } from 'src/features/Service/state/reducer'
import serviceContractReducer, { ServiceContractState } from 'src/features/ServiceContract/state/reducer'
import contractPaymentReducer, { ContractPaymentState } from 'src/features/CustomerPayment/state/reducer'
import cashboxReducer, { CashboxState } from 'src/features/CashboxStatement/state/reducer'
import chatReducer, { ChatState } from 'src/features/Chat/state/reducer'
import accountPayablesReducer, { AccountPayablesState } from 'src/features/AccountPayable/state/reducer'
import payableContractReducer, { PayableContractState } from 'src/features/PayableContract/state/reducer'
import reportReducer, { ReportState } from 'src/features/Report/state/reducer'
import quotationReducer, { QuotationState } from 'src/features/Quotation/state/reducer'

export interface RootState {
    accountPayables: AccountPayablesState
    apiLoader: ApiLoaderState
    cashbox: CashboxState
    chat: ChatState
    common: CommonState
    customer: CustomerState
    menu: MenuState
    payableContract: PayableContractState
    quotation: QuotationState
    report: ReportState
    security: SecurityState
    service: ServiceState
    serviceContract: ServiceContractState
    user: UserState
    contractPayment: ContractPaymentState
}

export default combineReducers<RootState>({
    accountPayables: accountPayablesReducer,
    apiLoader: apiLoaderReducer,
    cashbox: cashboxReducer,
    chat: chatReducer,
    customer: customerReducer,
    common: commonReducer,
    menu: menuReducer,
    payableContract: payableContractReducer,
    quotation: quotationReducer,
    report: reportReducer,
    service: serviceReducer,
    serviceContract: serviceContractReducer,
    contractPayment: contractPaymentReducer,
    security: securityReducer,
    user: userReducer,
})
